export default __webpack_public_path__ + "static/media/LB.4099d9da.ico";